export class VacationTransModel
{
vacnumber = 0 ;
vacdate = '2022-01-01' ;
vacempcode = '' ;
vackind = '' ;
vactype = '' ;
vacopenbalnce = 0 ;
vactransactions = 0 ;
vacbalance = 0 ;
vacfrom = '2022-01-01' ;
vacto = '2022-01-01' ;
vacdays = 0 ;
vacnote = '' ;
vacaltemp = '' ;
vacapproved = '' ;
vacperiod = '' ;
compcode = '' ;
userid = '' ;
modifieddate = '2022-01-01' ;

}

export class VacBalanceModel{
vacempcode = '' ;
vackind = '' ;
vactype = '' ;
approval = '' ;
vactot = 0 ;
compcode = '' ;

}

export class VacationDetModel{
detempcode = '' ;
detempdate :any ;
todate :any;
ttype = '' ;
empvactype = '' ;
compcode = '' ;
userid = '' ;
modifieddate = '2022-01-01' ;

}
